export default "__VITE_ASSET__CxyfN3Vu__"